/**
 * Sticky bottom bar component
 * Shows countdown and CTA on mobile and desktop
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether to show the bar
 * @param {number} props.spotsRemaining - Number of spots remaining
 * @param {string} props.countdownText - Formatted countdown text
 */
function StickyBar({ show, spotsRemaining, countdownText }) {
  if (!show) return null;

  return (
    <div className="mobile-sticky-bar visible bg-white border-t-2 border-indigo-200 shadow-2xl backdrop-blur-md" role="complementary" aria-label="Call to action">
      <div className="px-3 sm:px-6 lg:px-8 py-2.5 sm:py-4">
        <div className="max-w-7xl mx-auto">
          {/* Mobile layout */}
          <div className="flex sm:hidden flex-col gap-2">
            <div className="flex items-center justify-between gap-2">
              <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-lg px-2.5 py-1 border border-orange-200">
                <p className="text-xs font-semibold text-slate-700">
                  <span className="text-orange-600 font-extrabold tabular-nums">{countdownText}</span>
                </p>
              </div>
              <p className="text-xs text-slate-600">
                Only <span className="spots-remaining font-extrabold text-orange-600">{spotsRemaining}</span> spots left
              </p>
            </div>
            
            <div className="flex items-center justify-between gap-2">
              <p className="text-sm font-extrabold text-slate-900">
                Beta Tutor Access
              </p>
              <a href="#waitlist" className="btn-press flex-shrink-0 inline-flex items-center justify-center gap-1.5 rounded-lg bg-gradient-to-r from-indigo-600 to-purple-600 px-5 py-2.5 text-white text-sm font-bold hover:from-indigo-700 hover:to-purple-700 focus-ring shadow-lg">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M12 2l3 7h7l-5.5 4 2 7L12 17l-6.5 4 2-7L2 10h7l3-7z"/>
                </svg>
                Claim Your Spot
              </a>
            </div>
          </div>
          
          {/* Desktop layout */}
          <div className="hidden sm:flex items-center justify-between gap-4">
            <div className="flex items-center">
              <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-lg px-4 py-2 border border-orange-200">
                <p className="text-sm font-semibold text-slate-700">
                  Time left: <span className="text-orange-600 font-extrabold tabular-nums">{countdownText}</span>
                </p>
              </div>
            </div>
            
            <div className="flex-1 text-center">
              <p className="text-base font-extrabold text-slate-900">Beta Tutor Access</p>
              <p className="text-sm text-slate-600 mt-0.5">Only <span className="spots-remaining font-bold text-orange-600">{spotsRemaining}</span> spots left</p>
            </div>
            
            <div>
              <a href="#waitlist" className="cta-primary btn-press flex-shrink-0 inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 px-8 py-4 text-white text-base font-bold hover:from-indigo-700 hover:to-purple-700 focus-ring shadow-lg whitespace-nowrap">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M12 2l3 7h7l-5.5 4 2 7L12 17l-6.5 4 2-7L2 10h7l3-7z"/>
                </svg>
                Claim Your Spot
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StickyBar;
